import './vendor/lightgallery'
import {initBasicScripts} from './basic-scripts'
import VendorLoader from './vendor/loader'
import compatability from './compat'
import {imagesToSvg} from './utils'

import {Application} from './app'
import {readMore} from "./read-more";


compatability.applyPolyfills()

if (/edge\//i.test(navigator.userAgent)) {
    document.body.classList.add('edge')
}
if (/trident\//i.test(navigator.userAgent)) {
    document.body.classList.add('trident')
}
if (/Mobile\/.*Safari\//i.test(navigator.userAgent)) {
    document.body.classList.add('safari')
}

// Detect features
var specimen = document.createElement('detect').style
if (specimen.webkitBackdropFilter === '') {
    document.body.classList.add('backdrop-ok')
}
if (specimen.filter === '' || specimen.webkitFilter === '' || specimen.msFilter === '') {
    document.body.classList.add('filter-ok')
}

$(() => {
    // require("./vendor/fotorama");

    let vendorLoader = new VendorLoader()
    window.ajaxurl = typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp/wp-admin/admin-ajax.php'

    vendorLoader.load('addtocalendar')

    // require("./vendor/date-picker");
    // require("./vendor/date-picker-sv-SE"); // Swedish translation for DatePicker
    initBasicScripts()
    imagesToSvg('.replace-with-svg')
    readMore()

    window.app = new Application()
})











